import { useToast } from 'vue-toastification'

const AUTH_REDIRECT = Symbol('vaiAuthRedirect')

// vaiClient marks a 401 it already answered with the login redirect.
export const markVaiAuthRedirect = (error: object): void => {
  (error as Record<symbol, boolean>)[AUTH_REDIRECT] = true
}

export const isVaiAuthRedirect = (error: unknown): boolean => {
  return Boolean(error && typeof error === 'object' && (error as Record<symbol, boolean>)[AUTH_REDIRECT])
}

// The toast a vAI caller shows for its own failure (formatAiServiceError / getAgentErrorMessage),
// skipped on a 401: the user is already on the way to the login page.
export const notifyVaiError = (error: unknown, message: string): void => {
  if (isVaiAuthRedirect(error)) {
    return
  }

  useToast().error(message)
}
